import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import Foco from 'react-foco';
import styled from 'styled-components';
var Wrapper = styled(Foco)(_templateObject());
/**
 * Wrapper that handles outside clicks.
 * Based on Foco.
 * Replaces withOutsideClick hoc.
 */

export function WithOutsideClick(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(Wrapper, Object.assign({}, props), children);
}